<template>
  <div class="my_clazz">
    <van-nav-bar
      title="我的赛事"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />
    <my-race-panel v-for="(item, index) in joinList" :key="index" :race="item" />
    <div v-if="noList" class="empty">暂无赛事</div>
  </div>
</template>

<script>
import { Cell, NavBar } from 'vant'
import MyRacePanel from '@/views/home/components/MyRacePanel'
import { myRaceList } from '@/api/race'

export default {
  name: 'MyClazz',
  components: {
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    MyRacePanel
  },
  data () {
    return {
      isLoad: false,
      joinList: []
    }
  },
  computed: {
    noList () {
      return this.isLoad && !this.joinList.length
    }
  },
  created () {
    this.getJoinList()
  },
  methods: {
    async getJoinList () {
      let response = await myRaceList()
      this.isLoad = true
      this.pullLoading = false
      this.joinList = response.data
    },
    back () {
      this.$router.push('/my')
      // this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.empty {
  color: #969696;
  font-size: 28px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
